/*
  continuelink.js

  A small widget to offer end users
  a link to the session, to continue
  later.

  NB: Only use for anon. model which
      are set to save session.

  CC: Berkeley Bridge 2021

  Author: Tim Bauwens

*/

import { bb } from "$json";

let needed = true;
((doc, $) => {
  const bequiet = () => {
    const display = doc.querySelector(".p-continuelink-info .msg");
    display.style.opacity = 0;
  };

  const shout = msg => {
    const display = doc.querySelector(".p-continuelink-info .msg");
    display.innerText = msg;
    display.style.opacity = 1;
    window.setTimeout(bequiet, 2000);
  };

  const copy = e =>
    new Promise((resolve, reject) => {
      const container = e.target.parentNode;
      try {
        const link = container.querySelector(".link").innerText;
        navigator.clipboard.writeText(link).then(
          function () {
            resolve();
          },
          function (err) {
            reject();
          }
        );
      } catch (err) {
        reject();
      }
    });

  // Set the timestamp in the message
  function formatDateTwoWeeksFromNow() {
    const today = new Date();
    const twoWeeksLater = new Date(today.getTime() + 14 * 24 * 60 * 60 * 1000);

    const day = twoWeeksLater.getDate();
    const month = twoWeeksLater.toLocaleString("en", { month: "long" });
    const year = twoWeeksLater.getFullYear();

    const formattedDate = `${day} ${month} ${year}`;
    return formattedDate;
  }
  doc.querySelector(".p-continuelink-info .warning .time_stamp").innerText =
    formatDateTwoWeeksFromNow();

  $(doc).on("click", ".p-continuelink-button__copy", e => {
    copy(e)
      .then(() => shout("Gekopieerd!"))
      .catch(() =>
        shout("Het kopiëren lukte niet. Selecteer zelf de URL en kopiëer deze.")
      );
  });

  $(doc).on("click", ".p-continuelink-button__exit", e => {
    copy(e)
      .then(() => shout("Gekopieerd!"))
      .finally(() => {
        window.setTimeout(() => {
          bb.Mode.unset("hasCogs");
          window.scrollTo(0, 0);
          bb.exit();
        }, 1e3);
      });
  });

  $(doc).on("bb:postHandleData", (e, data) => {
    if (data && needed) {
      const linkdisplay = doc.querySelector(".p-continuelink-info .link");
      const { sessionid } = data;
      const linkurl = `https://tools.digitaltrustcenter.nl/security-check-procesautomatisering-doorgaan/?modelname=${data.modelname}&sessionid=${sessionid}`;
      linkdisplay.textContent = linkurl;
      needed = false;
    }
  });
})(document, jQuery);
